import { OperationDetailsContent } from '@/entities/operation';
import type { OperationDto } from '@/shared/types';

type Props = {
  operation: OperationDto;
  topOffset: number;
  onClose: () => void;
  onStatusChange?: () => void;
};

const BOTTOM_GAP = 24;
const HEADER_HEIGHT = 56;

export const OperationDetailsPanel = ({
  operation,
  topOffset,
  onClose,
  onStatusChange,
}: Props) => (
  <aside
    className="sticky flex w-[32rem] shrink-0 flex-col self-start"
    style={{
      top: topOffset,
      maxHeight: `calc(100dvh - ${HEADER_HEIGHT + topOffset + BOTTOM_GAP}px)`,
    }}>
    <OperationDetailsContent
      key={operation.operaionid}
      operation={operation}
      onClose={onClose}
      onStatusChange={onStatusChange}
    />
  </aside>
);
